import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thaibaht'
})
export class ThaiBahtPipe implements PipeTransform {
  private thaiNum = ['à¸¨à¸¹à¸à¸¢à¹', 'à¸«à¸à¸¶à¹à¸', 'à¸ªà¸­à¸', 'à¸ªà¸²à¸¡', 'à¸ªà¸µà¹', 'à¸«à¹à¸²', 'à¸«à¸', 'à¹à¸à¹à¸', 'à¹à¸à¸', 'à¹à¸à¹à¸²'];
  private thaiUnit = ['', 'à¸ªà¸´à¸', 'à¸£à¹à¸­à¸¢', 'à¸à¸±à¸', 'à¸«à¸¡à¸·à¹à¸', 'à¹à¸ªà¸', 'à¸¥à¹à¸²à¸'];

  transform(value: any, args?: any): any {
    if (isNaN(value) || value === null) { return value; }

    const splitArray = parseFloat(value).toFixed(2).toString().split('.');
    const bahtArray = splitArray[0].replace('-', '')
      .split('')
      .reverse()
      .map((val: string) => parseInt(val, 10));

    const resultBahtArray = [];

    resultBahtArray.push('à¸à¸²à¸');
    const resultBaht = this.transformArray(bahtArray);
    resultBahtArray.push(resultBaht.reverse().join(''));

    if (splitArray[1] === undefined || splitArray[1] === '00') {
      return resultBahtArray.reverse().join('') + 'à¸à¹à¸§à¸';
    }

    const satangArray = splitArray[1].replace('-', '')
      .split('')
      .reverse()
      .map((val: string) => parseInt(val, 10));

    const resultSatangArray = [];

    resultSatangArray.push('à¸ªà¸à¸²à¸à¸à¹');
    const resultSatang = this.transformArray(satangArray).join('');
    resultSatangArray.push(resultSatang);

    return resultBahtArray.reverse().join('') + resultSatangArray.reverse().join('');
  }

  private transformArray(array: any[]) {
    return this.chunkArray(array, 6).map((chunk, chunkIndex) => {
      const chunkResult = [];

      if (chunkIndex > 0) {
        chunkResult.push('à¸¥à¹à¸²à¸');
      }

      chunk.forEach((num: number, index: number) => {
        if (num === 0 && chunk[index + 1] !== undefined) {
          return;
        }

        if (num === 1 && index === 0 && chunk.length === 2 && chunk[1] === 0) {
          chunkResult.push('à¸«à¸à¸¶à¹à¸');
          return;
        }

        if (num === 1 && index === 0 && chunk.length > 1) {
          chunkResult.push('à¹à¸­à¹à¸');
          return;
        }

        if (num === 1 && index === 1) {
          chunkResult.push(this.thaiUnit[index]);
          return;
        }

        if (num === 2 && index === 1) {
          chunkResult.push('à¸¢à¸µà¹' + this.thaiUnit[index]);
          return;
        }

        if (num === 0 && index !== 0) {
          return;
        }

        chunkResult.push(this.thaiNum[num] + this.thaiUnit[index]);
      });

      return chunkResult.reverse().join('');
    });
  }

  private chunkArray(array: any[], size: number) {
    const results = [];

    while (array.length) {
      results.push(array.splice(0, size));
    }

    return results;
  }
}
